import Content from "../content/Content";

const Constants = {
    DEV_MODE: false,
    DEBUG_MODE: true,
    REACT_KEY: 1,
    SCREEN_SIZE: '990px',
    URL: {

    },
    ICONS:{
        LOGO_CREWKARMA: 'https://storage.googleapis.com/ck-staging/ck-logo-white.svg',
        LOGO_WHITE_2: "https://storage.googleapis.com/ck-prod/new_logo_txo3.png",
        COINS_BLUE: 'https://storage.googleapis.com/ck-prod/ck_app_assets/ck-icon-coins-blue.svg',
        BOOST_JOB_BLUE: 'https://storage.googleapis.com/ck-prod/ck_app_assets/ck-icon-boost-job-blue.svg',
        PEOPLE_BLUE: 'https://storage.googleapis.com/ck-prod/ck_app_assets/ck-icon-people-blue.png',
        UNLOCK_BLUE: 'https://storage.googleapis.com/ck-prod/ck_app_assets/ck-icon-unlock-blue.png',
    },
    FAQ_BUTTON: {
        CONTACT_US: 1,
        START_HIRING: 2,
        POST_A_JOB: 3,
        KNOW_MORE: 4
    },
    FAQ_LINKS_REDIRECT: {
        PREMIUM_FEATURE_SECTION: 1,
        START_HIRING: 2,
        POST_A_JOB: 3,
        JOBS_LISTING_PAGE: 4
    },
    MODAL_ROUTES:{
        EDU_MODAL : {
            // route :"/education-modal",
            // type : "education"
        }
    },
    ROUTE: {
        REACT_ROUTES : {
            USER_PROFILE: "/admin-profile/",
            EDIT_PROFILE : "/profileadmin/edit",
            AVAILABLE_FOR_HIRE: "/availableforhire",
            JOBS: "/jobs",
            MOBILE_HOME_WITH_LOGIN: "/?login=3"
        },
        AUTH_CHECK: "/authcheck",
        RECRUITER_DASHBOARD_COMMON_HANDLER: "/recruiterdashboardcommonhandle",
    },

    REQUEST_ACTION_TYPE: {
        RECRUITER_DASHBOARD_COMMON_HANDLER: {
            GET_ACTION_GET_COIN_RATE: "action_get_coin_rate"
        }
    },

    PAGE_IDENTIFIERS: {

    },

    FILTER_TYPES : {

    },

    FILTER_CATEGORY : {

    },

    ITEM_TYPES: {

    },

    LOGIN_TYPE: {
        PROFESSIONAL: 1,
        RECRUITER: 2
    },

    KEY_CODE: {

    },
    //Making server calls  1. show loading image    2. show data view   3. show failure view
    REQUEST_STATS: {
        PENDING: 1,
        SUCCESS: 2,
        FAILURE: 3
    },

    USER_TYPE: {
        CANDIDATE : 1,
        RECRUITER : 2
    },

    REGEX: {
        MOBILE: /^(?:\+\d+[- ])?\d{10}$/,
        EMAIL: /^[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/,
        URL: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/|www\.)?[A-Za-z0-9]+([\-\.]{1}[A-Za-z0-9]+)*\.[A-Za-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/,
        CTC: /^(\d{1,2}|\d{0,2}\.\d{1,2})?(?![\d.])$/,
        ONLY_ALPHABETS : /^[a-zA-Z ]*$/
    },

    SUPPORTED_FILE_TYPE_LIST : [
        "doc",
        "docx",
        "xls",
        "xlsx",
        "ppt",
        "pptx",
        "pdf"
    ],

    IMG_FORMAT_SUPPORTED : [
        "jpg",
        "jpeg",
        "png",
        "bmp"
    ],

    FILE_ICON_LIST: {

    },

    // DEFAULT_WEB_ICON: "https://image.freepik.com/free-icon/zip-file_318-9916.jpg",

    REQ_TIMEOUT: 15 * 60 * 1000,

    STYLES: {
        FONT_REG: "GillSans Regular",
        FONT_ITALIC_REG: "GillSans Italic Regular",
        COLOR_ERR: "#D0021B",
        COLOR_FOCUS: "#0028ea",
        COLOR_DEFAULT: "#CFCFCF"
    },

    BLANK_IMG_BLOB: 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7',
    FAQ_QUERY_PARAMS: {
        ABOUT: "about",
        START: "start",
        PREMIUM: "premium",
        PRICING: "pricing"
    },
    GET_MORE_PROFILES : {
        TYPE_BOOST: 1,
        TYPE_DB_ACCESS: 2
    },
    FAQ_SEARCH_PARAMS: "info"
    
};

export default Constants;


// WEBPACK FOOTER //
// ./src/constants/Constants.js